import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { getMomentLocale, localizeNumber } from '@helpers/locale';

function CsvRow({ csv_upload }) {
  const momentLocale = getMomentLocale(BFG.locales.staticSiteLocale);

  const renderCsvRow = () => {
    const {
      created_at,
      creator_email,
      failed_count,
      status,
      succeeded_count,
      total_count,
      validation_failure_count,
      validation_failure_download_url,
    } = csv_upload?.attributes;
    return (
      <>
        <span className="twenty-five">
          { moment(created_at).locale(momentLocale).format('L, LT') }
        </span>
        <span className="thirty">
          { creator_email }
        </span>
        <span className="ten center">
          { localizeNumber(succeeded_count) }
        </span>
        <span className="ten center">
          {validation_failure_count > 0
            ? (
              <a
                aria-label={t("Download file describing validation failures")}
                href={validation_failure_download_url}
                download
              >
                { localizeNumber(validation_failure_count) }
              </a>
            ) : localizeNumber(validation_failure_count)
          }
        </span>
        <span className="ten center">
          { localizeNumber(failed_count) }
        </span>
        <span className="ten center">
          { localizeNumber(total_count) }
        </span>
        <span className="ten center capitalize">
          { status }
        </span>
      </>
    );
  };

  return renderCsvRow();
}

CsvRow.propTypes = {
  csv_upload: PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.shape({
      created_at: PropTypes.string,
      status: PropTypes.string,
      creator_email: PropTypes.string,
      total_count: PropTypes.number,
      succeeded_count: PropTypes.number,
      failed_count: PropTypes.number,
    })
  }).isRequired
};

export default CsvRow;
